import WForeverDesktop from './WForeverDesktop'

export default WForeverDesktop
